<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-row>
					<b-col>
						<h2 class="inline-heading">Coordinacion</h2>
					</b-col>
				</b-row>
				<hr />
				<Filters
					coordinator-mode
					id="reservations-index-filters"
					:filters.sync="filters"
					@search="
						() =>
							$root.$emit(
								'bv::refresh::table',
								'reservations-index-list'
							)
					"
				/>
					<b-form-group class="text-right mt-2">
					<b-overlay  :show="exportLoading" class="d-inline-block" rounded="sm">
						<b-dropdown
							v-if="$hasPermission('coordination.export')"
							right
							text="Exportar XLS"
							class="mr-2"
							variant="warning"
						>
							<b-dropdown-item @click="() => exportXLS(false)"
								>Sin costos</b-dropdown-item
							>

						</b-dropdown>
					</b-overlay>
				</b-form-group>
				<hr />

				<AjaxTable
					permission-show="coordination.show"
					id="reservations-index-list"
					ref="childtable"
					stacked="lg"
					:show-select-all="showSelectAll"
					:selected-items.sync="items"
					:filters="filtersClean"
					:columns="filteredColumns"
					:items-filter="itemsFilter"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="transport-services"
					responsive
				>
					<template #cell(actions)="row">
						<div class="d-flex">
							<b-button
								@click="
									event =>
										viewForm(
											row.item,
											row.index,
											event,
											row.item
										)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="visibility"></md-icon>
							</b-button>
						</div>
					</template>
					<template #cell(clientName)="row">
						{{ row.item.reservation.client.firstName }}
						{{ row.item.reservation.client.lastName }}
					</template>
					<template #cell(clientEmail)="row">
						{{ row.item.reservation.client.email }}
					</template>
					<template #cell(pickup)="row">
						{{ row.item.pickup.name }}
					</template>
					<template #cell(dropoff)="row">
						{{ row.item.dropoff.name }}
					</template>
					<template #cell(passengers)="row">
						{{
							row.item.reservation.adults +
								row.item.reservation.children +
								row.item.reservation.infants
						}}
					</template>
					<template #cell(serviceType)="row">
						{{ row.item.serviceType.name }}
					</template>
					<template #cell(contactStatus)="row">
						{{ contactStatusLabels[row.item.contactStatus] }}
					</template>
					<template #cell(salesChannel)="row">
						<span style="white-space: nowrap;"
							><b-badge
								v-if="row.item.sourceLabel"
								variant="info"
								class="ml-1"
								>{{ row.item.sourceLabel }}</b-badge
							>
							{{ row.item.salesChannel.name }}</span
						>
					</template>
					<template #cell(pickupDatetime)="row">
						{{ row.item.pickupDatetime }}
					</template>

					<template #cell(flightDatetime)="row">
						<span
							:class="
								row.item.flightValidationStatus !== 'none'
									? 'text-success text-center'
									: 'text-danger text-center'
							"
						>
							<md-icon
								:icon="
									row.item.flightValidationStatus !== 'none'
										? 'check_circle'
										: 'info'
								"
							/>
						</span>
						{{ row.item.flightDatetime }} /
						{{ row.item.flightNumber }}
					</template>

					<template #cell(status)="row">
						{{ statusLabels[row.item.status] }}
					</template>
				</AjaxTable>
			</div>
		</div>
		<FormReservation
			coordinator-mode
			:tsSelectedId="selected.tsSelectedId"
			:model-id="selected.modalModelId"
			:copy-from-id="selected.copyResId"
			:formTypeWork="formTypeWork"
			@changeId="selected.modalModelId = $event"
			@onCopyRes="copyCurrentRes"
			v-model="form.add"
		/>
		<ImportModal />
		<AssignSuplierModal :selected.sync="items" />
		<AssignStatusModal :selected.sync="items" />
		<AssignSupplierConfirmationModal :selected.sync="items" />
		<CalculateMassivePickupsModal
			:selected.sync="items"
			:res-view="viewForm"
		/>
		<vue-snotify />
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout";
import AjaxTable from "../../helpers/AjaxTable";
import ImportModal from "./ImportModal";
import AssignSuplierModal from "./AssignSuppliers/AssignSuplierModal";
import AssignStatusModal from "./AssignStatusModal";
import Filters from "./Filters";
import AssignSupplierConfirmationModal from "./AssignSupplierConfirmationModal";
import CalculateMassivePickupsModal from "./CalculateMassivePickupsModal";
import api from "../../../api.js";
import moment from "moment";
import { mapMutations, mapState } from "vuex";

//New version form
import FormReservation from "../reservation/formReservation/index";

export default {
	components: {
		FormReservation,
		MainLayout,
		ImportModal,
		AssignSuplierModal,
		AssignStatusModal,
		AssignSupplierConfirmationModal,
		AjaxTable,
		CalculateMassivePickupsModal,
		Filters
	},
	data() {
		let defaultFilters = {
			id: "",
			clientFullName: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			airport: [],
			serviceType: [],
			serviceTypeCategory: [],
			pickupStartDate: "",
			pickupEndDate: "",
			creationStartDate: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
			trip: 0,
			contactStatus: 0,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			creationUser: []
		};
		return {
			formTypeWork:'newForm',//viewForm -newForm- newFormCopy - newFormLocationReferences
			form: {
				add: false
			},
			selected: {
				modalModelId: -1,
				tsSelectedId: -1,
				copyResId: -1
			},

			items: [],
			pendingNotifications: 0,
			exportLoading: false,
			showSelectAll: false,

			sortBy: "reservationId",
			sortDesc: true,
			filters: { ...defaultFilters },
			modelColumns: [
				{
					key: "reservationId",
					label: "Res ID",
					sortable: true,
					disabled: true
				},
				{ key: "clientName", label: "Cliente" },
				{ key: "pickup", label: "Pickup" },
				{ key: "dropoff", label: "Dropoff" },
				{ key: "passengers", label: "Pasajeros" },
				{
					key: "pickupDatetime",
					label: "Fecha Pickup",
					sortable: true
				},
				{ key: "flightDatetime", label: "Fecha Vuelo" },
				{ key: "serviceType", label: "Tipo servicio" },
				{ key: "salesChannel", label: "Canal de venta" },
				{ key: "trip", label: "Viaje" },
				{ key: "actions", label: "Acciones", disabled: true }
			]
		};
	},
	computed: {
		...mapState("reservation", ["quote"]),
		filteredColumns() {
			let aux = [];
			if (this.showSelectAll) {
				aux.push({ key: "selected", label: "" });
			}
			aux = aux.concat(this.modelColumns);
			return aux;
		},
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				destination: this.filters.destination.map(aux => aux.value),
				airport: [1715],
				salesChannel: this.filters.salesChannel.map(aux => aux.value),
				supplier: this.filters.supplier.map(aux => aux.value),
				creationUser: this.filters.creationUser.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				serviceTypeCategory: this.filters.serviceTypeCategory.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupEndDate: this.filters.pickupEndDate,
				creationStartDate: this.filters.creationStartDate,
				creationEndDate: this.filters.creationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				trip: "A2H",
				contactStatus: this.filters.contactStatus,
				status: this.filters.status.map(aux => aux.value),
				statusCheckin: this.filters.statusCheckin.map(aux => aux.value),
				salesChannelReference: this.filters.salesChannelReference,
				supplierReference: this.filters.supplierReference,
				containsEmail: this.filters.containsEmail,
				clientEdited: this.filters.clientEdited,
				clientConfirmed: this.filters.clientConfirmed,
				pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
				fromPointOfSale: this.filters.fromPointOfSale,
				supplierConfirmation: this.filters.supplierConfirmation,
				placesWithoutCoordinates: this.filters.placesWithoutCoordinates,
				supplierPriceTotalEmpty: this.filters.supplierPriceTotalEmpty
			};
		},
		contactStatusLabels() {
			let vars = this.$root.auxVars.transportServiceContactStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		checkinStatusVars() {
			let vars = this.$root.auxVars.webCheckingStatus;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = { ...vars[i] };
			}
			return opts;
		},
		paymentStatusVars() {
			let vars = this.$root.auxVars.transportServicePaymentStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = { ...vars[i] };
			}
			return opts;
		},
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		serviceStatusVariants() {
			let aux = {};
			this.$root.auxVars.transportServiceStatusOpts.map(status => {
				aux[status.value] = status.class;
			});
			return aux;
		}
	},
	methods: {
		...mapMutations("reservation", [
			"SET_RESET_MODEL",
			"SET_UPDATE_QUOTE_PROPS"
		]),
		copyCurrentRes() {
			this.selected.copyResId = this.selected.modalModelId;
			this.selected.modalModelId = -1;
			this.form.add = true;
		},
		itemsFilter(items) {
			return items.map(item => ({
				...item,
				pickupDatetime: moment(item.pickupDatetime).format(
					"DD/MM/YYYY HH:mm"
				),
				flightDatetime: item.flightDatetime
					? moment(item.flightDatetime).format("DD/MM/YYYY HH:mm")
					: "",
				_rowVariant: this.serviceStatusVariants[item.status]
			}));
		},
		showImportModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-import-view",
				event.target
			);
		},
		showAssignSupplierModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-supplier-view",
				event.target
			);
		},
		showAssignStatusModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-status-view",
				event.target
			);
		},
		showAssignSupplierConfirmationModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-supplier-confirmation-view",
				event.target
			);
		},
		showCalculatePickupModal() {
			this.$root.$emit(
				"bv::show::modal",
				"calculate-massive-pickups",
				event.target
			);
		},
		toggleMassiveAssign() {
			if (!this.showSelectAll) {
				this.$refs.childtable.showMax();
			}
			this.showSelectAll = !this.showSelectAll;
		},
		exportXLS(withPrices) {
			this.exportLoading = true;
			api(this)
				.get(`/transport-services/export`, {
					params: {
						sortBy: this.sortBy,
						sortOrder: this.sortDesc ? "desc" : "asc",
						filters: this.filtersClean,
						withPrices: withPrices ? withPrices : null
					},
					responseType: "blob"
				})
				.then(res => {
					let fileType = res.headers["content-type"] ?? "";
					let ext = fileType.includes("text/csv") ? "csv" : "xlsx";

					let blob = new Blob([res.data]);
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = url;
					a.download = "TransportServices." + ext;
					a.click();
					window.URL.revokeObjectURL(url);
					this.exportLoading = false;
				})
				.catch(error => {
					this.$root.handleRequestError(error);
					this.exportLoading = false;
				});
		},
		viewForm(item) {
			this.selected.tsSelectedId = item.id;
			this.selected.copyResId = -1;
			this.selected.modalModelId = item.reservationId;
			this.form.add = true;
			this.formTypeWork='viewForm'
		},
		copyRes(resId) {
			this.selected.copyResId = resId;
			this.selected.modalModelId = -1;
			this.form.add = true;
			this.formTypeWork='newFormCopy'
		},
		newForm() {
			this.SET_RESET_MODEL();
			this.selected.copyResId = -1;
			this.selected.modalModelId = -1;
			this.form.add = true;
			this.formTypeWork='newForm'
		},
		resetPropsReservations() {
			this.selected.tsSelectedId = -1;
			this.selected.copyResId = -1;
			this.selected.modalModelId = -1;
		},
		userDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/reservations/${item.id}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.$emit(
								"bv::refresh::table",
								"reservations-index-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},

		showDayBeforeOperation() {
			let pickUpStart = moment()
				.subtract(3, "days")
				.format("YYYY-MM-DD");
			let pickUpEnd = moment()
				.subtract(1, "days")
				.format("YYYY-MM-DD");
			this.filters.id = 0;
			this.filters.clientFullName = "";
			this.filters.destination = [];
			this.filters.salesChannel = [];
			this.filters.supplier = [];
			this.filters.airport = [];
			this.filters.serviceType = [];
			this.filters.pickupStartDate = pickUpStart;
			this.filters.pickupEndDate = pickUpEnd;
			(this.filters.creationStartDate = ""),
				(this.filters.creationEndDate = ""),
				(this.filters.cancelationStartDate = ""),
				(this.filters.cancelationEndDate = ""),
				(this.filters.trip = 0);
			this.filters.contactStatus = 0;
			this.filters.status = [{ value: "active", text: "Activo" }];
			this.filters.salesChannelReference = "";
			this.filters.supplierReference = "";
			this.filters.containsEmail = "";
			this.filters.clientEdited = "";
			(this.filters.clientConfirmed = ""),
				(this.filters.showAdvancedOptions = false),
				this.$root.$emit(
					"bv::refresh::table",
					"reservations-index-list"
				);
		},
		showDayAfterOperation(supplierData) {
			let pickUpStart = moment()
				.add(1, "days")
				.format("YYYY-MM-DD");
			let pickUpEnd = moment()
				.add(1, "days")
				.format("YYYY-MM-DD");
			this.filters.id = 0;
			this.filters.clientFullName = "";
			this.filters.destination = [];
			this.filters.salesChannel = [];
			this.filters.supplier = [supplierData];
			this.filters.airport = [];
			this.filters.serviceType = [];
			this.filters.pickupStartDate = pickUpStart;
			this.filters.pickupEndDate = pickUpEnd;
			(this.filters.creationStartDate = ""),
				(this.filters.creationEndDate = ""),
				(this.filters.cancelationStartDate = ""),
				(this.filters.cancelationEndDate = ""),
				(this.filters.trip = 0);
			this.filters.contactStatus = 0;
			this.filters.status = [{ value: "active", text: "Activo" }];
			this.filters.salesChannelReference = "";
			this.filters.supplierReference = "";
			this.filters.containsEmail = "";
			this.filters.clientEdited = "";
			(this.filters.clientConfirmed = ""),
				(this.filters.showAdvancedOptions = false),
				this.$root.$emit(
					"bv::refresh::table",
					"reservations-index-list"
				);
		},
		launchNotifications(toast) {
			this.pendingNotifications = 0;
			api(this)
				.get(`/notifications-get`, {})
				.then(res => {
					let beforeOperationRows =
						res.data.dayBeforeOperation.totalRows;
					if (beforeOperationRows > 0) {
						this.pendingNotifications =
							this.pendingNotifications + 1;
						if (toast) {
							this.$snotify.info(
								"Existen " +
									beforeOperationRows +
									" reservaciones pendientes por revisar. ¿Deseas que el sistema las muestre?",
								"Operación de ayer",
								{
									timeout: 10000,
									showProgressBar: true,
									closeOnClick: false,
									pauseOnHover: true,
									titleMaxLength: 30,
									snotifyType: "info",
									buttons: [
										{
											text: "Si",
											action: toast => {
												this.showDayBeforeOperation();
												this.$snotify.remove(toast.id);
											},
											bold: true
										},
										{
											text: "No",
											action: toast => {
												this.$snotify.remove(toast.id);
											},
											bold: false
										}
									]
								}
							);
						}
						let afterOperationRows =
							res.data.dayAfterOperation.totalRows;
						let supplierData =
							res.data.dayAfterOperation.supplierData;
						if (afterOperationRows > 0) {
							this.pendingNotifications =
								this.pendingNotifications + 1;
							if (toast) {
								this.$snotify.info(
									"Existen " +
										afterOperationRows +
										" reservaciones pendientes por asignar proveedor. ¿Deseas que el sistema las muestre?",
									"Operación de mañana",
									{
										timeout: 10000,
										showProgressBar: true,
										closeOnClick: false,
										pauseOnHover: true,
										titleMaxLength: 30,
										buttons: [
											{
												text: "Si",
												action: toast => {
													this.showDayAfterOperation(
														supplierData
													);
													this.$snotify.remove(
														toast.id
													);
												},
												bold: true
											},
											{
												text: "No",
												action: toast => {
													this.$snotify.remove(
														toast.id
													);
												},
												bold: false
											}
										]
									}
								);
							}
						}
						/* 						let invalidMailDestinationRows = res.data.invalidMailDestination.totalRows;
						let destinationData = res.data.invalidMailDestination.destinationData;
						if (invalidMailDestinationRows > 0) {
							this.pendingNotifications = this.pendingNotifications + 1;
							if (toast) {
								this.$snotify.info('Existen ' + invalidMailDestinationRows + ' reservaciones pendientes por asignar destinos para envio de mails. ¿Deseas que el sistema las muestre?', 'Mails automáticos', {
									timeout: 10000,
									showProgressBar: true,
									closeOnClick: false,
									pauseOnHover: true,
									titleMaxLength: 30,
									buttons: [
										{text: 'Si', action: (toast) => {this.showInvalidMailDestination(destinationData); this.$snotify.remove(toast.id); }, bold: true},
										{text: 'No', action: (toast) => {this.$snotify.remove(toast.id); }, bold: false},
									]
								});
							}
						} */
					}
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				});
		},
		iconSupplierConfirmation(status) {
			let icon = "";
			let classe = "";
			switch (status) {
				case "pending":
					icon = "warning";
					classe = "text-warning";
					break;
				case "confirmed":
					icon = "check_circle";
					classe = "text-success";
					break;
				case "rejected":
					icon = "dangerous";
					classe = "text-danger";
					break;
			}
			return { icon: icon, class: classe };
		}
	},
	mounted() {
		let notificationDay = moment().format("YYYY-MM-DD");
		if (notificationDay != localStorage.getItem("last-notification-day")) {
			localStorage.setItem("last-notification-day", notificationDay);
			this.launchNotifications(true);
		} else {
			this.launchNotifications(false);
		}
	},
	created() {},
	watch: {}
};
</script>

<style>
.multiselect__tags {
	max-height: 150px;
	overflow-y: auto;
	overflow-y: auto;
}
.active-filter {
	border: 2px solid #021d3e;
}
.snotifyToast__title {
	font-size: 1.5em;
}
.inline-heading {
	display: inline;
}
.inline-button {
	margin-bottom: 10px;
}
</style>
